import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { utilVersion } from "../../utils/utilVersion";
export var SceneLoading = function (_a) {
    var bundles = _a.bundles;
    var total = bundles.reduce(function (acc, bundle) { return acc + bundle.progress; }, 0);
    var progress = total / bundles.length || 0;
    var style = {
        width: progress + "%",
    };
    return (React.createElement("div", { className: "loading-wrapper" },
        React.createElement("div", { className: "loading-background" }),
        React.createElement("div", { className: "" + IdStyles.LoadingLogo }),
        React.createElement("div", { className: IdStyles.LoadingBarBackground + " loading-progress-background" },
            React.createElement("div", { className: "loading-progress-fill " + IdStyles.LoadingBarFillDefault, style: style }),
            React.createElement("div", { className: "loading-progress-text " + IdStyles.TextBoldAccent },
                progress.toFixed(0),
                "%")),
        React.createElement("div", { className: "loading-version " + IdStyles.TextBoldAccent },
            "v",
            utilVersion.getCurrentVersion()),
        React.createElement("div", { id: "preload-icons" },
            React.createElement("div", { className: "sprite-icons-ui-m" }),
            React.createElement("div", { className: "sprite-icons-ui-l" }),
            React.createElement("div", { className: "sprite-icons-ui-xl" }),
            React.createElement("div", { className: "sprite-buildings-ui" }),
            React.createElement("div", { className: "sprite-profiles-large" }),
            React.createElement("div", { className: "big-character_tessa" }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/loading/SceneLoading.tsx
// module id = 2232
// module chunks = 3